import ReportsList from '@/components/reports/list/ReportsList.vue'
import SummaryReports from '@/components/reports/summaryreports/SummaryReports.vue'
import DrnSummaryReports from '@/components/reports/drnsummary/DrnSummaryReports.vue';
import BillReports from '@/components/reports/billreports/BillReports.vue'
import RegenerationsReport from '@/components/reports/regenerations/RegenerationsReport.vue'
import { mapState } from 'vuex';

export default {
  components: {
    ReportsList,
    SummaryReports,
    DrnSummaryReports,
    BillReports,
    RegenerationsReport
  },
  data () {
    return {
      isMounted: false,
      clientApiId: null
    }
  },
  computed: {
    ...mapState(['config'])
  },
  mounted () {
    if (this.$route.path === '/client-reports' && !this.ApiRequest.userHasPermission('view-clients')) {
      this.clientApiId = this.BasicHelper.getUserClientApiId();
    }
    this.isMounted = true;
  }
}
